import React from 'react';
import { FileTextIcon, UsersIcon, StarIcon, HeartIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-white border-b border-gray-200 py-12 px-4" data-id="element-252">
      <div className="max-w-6xl mx-auto" data-id="element-253">
        {/* Top Banner */}
        <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 max-w-3xl mx-auto" data-id="element-254">
          <div className="flex -space-x-3" data-id="element-255">
            <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-xs border-2 border-white" data-id="element-256">
              LM
            </div>
            <div className="w-10 h-10 rounded-full bg-purple-500 flex items-center justify-center text-white font-bold text-xs border-2 border-white" data-id="element-257">
              FR
            </div>
            <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center text-white font-bold text-xs border-2 border-white" data-id="element-258">
              GV
            </div>
            <div className="w-10 h-10 rounded-full bg-pink-500 flex items-center justify-center text-white font-bold text-xs border-2 border-white" data-id="element-259">
              AM
            </div>
          </div>
          <p className="text-green-800 font-semibold text-center sm:text-left" data-id="element-260">
            ✅ Già scelto da 2.847+ insegnanti in tutta Italia
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-261">
          <div className="flex flex-col items-center text-center p-4 rounded-xl bg-blue-50" data-id="element-262">
            <FileTextIcon className="w-8 h-8 text-blue-600 mb-2" data-id="element-263" />
            <span className="text-2xl font-bold text-gray-900" data-id="element-264">300+</span>
            <span className="text-sm text-gray-600 font-medium" data-id="element-265">
              Risorse digitali
            </span>
          </div>

          <div className="flex flex-col items-center text-center p-4 rounded-xl bg-orange-50" data-id="element-266">
            <UsersIcon className="w-8 h-8 text-orange-600 mb-2" data-id="element-267" />
            <span className="text-2xl font-bold text-gray-900" data-id="element-268">2.8k+</span>
            <span className="text-sm text-gray-600 font-medium" data-id="element-269">
              Insegnanti attivi
            </span>
          </div>

          <div className="flex flex-col items-center text-center p-4 rounded-xl bg-green-50" data-id="element-270">
            <StarIcon className="w-8 h-8 text-yellow-500 fill-yellow-500 mb-2" data-id="element-271" />
            <span className="text-2xl font-bold text-gray-900" data-id="element-272">4.9/5</span>
            <span className="text-sm text-gray-600 font-medium" data-id="element-273">
              Valutazione media
            </span>
          </div>

          <div className="flex flex-col items-center text-center p-4 rounded-xl bg-red-50" data-id="element-274">
            <HeartIcon className="w-8 h-8 text-red-500 fill-red-500 mb-2" data-id="element-275" />
            <span className="text-2xl font-bold text-gray-900" data-id="element-276">100%</span>
            <span className="text-sm text-gray-600 font-medium" data-id="element-277">
              Soddisfazione
            </span>
          </div>
        </div>
      </div>
    </section>;
}